import { Link } from 'react-router-dom';
import { useLocalizedPath } from '@/hooks/useI18n';
import { useTranslation } from '@/hooks/useTranslation';
import { Container } from '@/components/Container';
import { PrevisaoTempoHoje } from '@/components/PrevisaoTempoHoje';
import { MareWidget } from '@/components/MareWidget';

export function WidgetsSection() {
  const { t } = useTranslation();
  const localize = useLocalizedPath();

  return (
    <section className="py-16 sm:py-20 bg-sand-50">
      <Container>
        <div className="text-center mb-12">
          <span className="font-body text-sm text-coral font-semibold uppercase tracking-wider">
            {t('home.widgets.overline')}
          </span>
          <h2 className="font-display text-4xl sm:text-5xl text-warm-dark mt-1">
            {t('home.widgets.title')}
          </h2>
          <p className="font-editorial text-lg text-warm-gray mt-2 max-w-2xl mx-auto">
            {t('home.widgets.subtitle')}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 items-start">
          {/* Previsão do tempo */}
          <div className="bg-white rounded-2xl border border-sand-200 p-5 shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
            <PrevisaoTempoHoje />
            <div className="mt-4 pt-4 border-t border-sand-200">
              <Link
                to={localize('/previsao-do-tempo-na-ilha-do-mel')}
                className="inline-flex items-center gap-2 w-full justify-center bg-teal-deep hover:bg-[#0a6666] text-white font-body font-semibold rounded-xl px-5 py-3 transition-all"
              >
                {t('home.widgets.weatherCta')}
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            </div>
          </div>

          {/* Tábua de maré */}
          <div className="bg-white rounded-2xl border border-sand-200 p-5 shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
            <MareWidget variant="compact" showCta={false} />
            <div className="mt-4 pt-4 border-t border-sand-200">
              <Link
                to={localize('/como-chegar-na-ilha-do-mel')}
                className="inline-flex items-center gap-2 w-full justify-center bg-coral hover:bg-[#c96a52] text-white font-body font-semibold rounded-xl px-5 py-3 transition-all"
              >
                {t('home.widgets.tideCta')}
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
